import { httpRequest } from "../../../utils/HttpRequest";
import {
    IKey,
    IMdCmFields,
    IPage,
    ISearchPageField
} from "../../../types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";

export interface IMdSupplierFields extends IMdCmFields {
    linkCode?: string;
    code?: string;
    name?: string;
    categoryCode?: string;
    categoryName?: string;
    level?: number;
    contact?: string;
    phone?: string;
    tel?: string;
    fax?: string;
    email?: string;
    website?: string;
    address?: string;
    invoiceHeader?: string;
    businessLicenseNo?: string;
    bank?: string;
    bankAccount?: string;
    postAddress?: string;
    corporation?: string;
    businessScope?: string;
    status?: number;
    note?: string;
    shopCode?: string
}

export type IMdSupplierDetail = IKey & IMdCmFields & IMdSupplierFields;
export type IMdSupplierSearch = IMdSupplierFields & ISearchPageField;

class SupplierService {
    async insert(insertVo: IMdSupplierFields) {
        const apiUrl = "/supplier/insert";
        return await httpRequest.post<IMdSupplierDetail>(apiUrl, insertVo);
    }

    async update(updateVo: IMdSupplierFields) {
        const apiUrl = "/supplier/update";
        return await httpRequest.post<IMdSupplierDetail>(apiUrl, updateVo);
    }

    async disable(oneVo: IMdSupplierFields) {
        const apiUrl = "/supplier/disable";
        return await httpRequest.post<boolean>(apiUrl, oneVo);
    }

    async find(searchVo: IMdSupplierFields, config: object = {}) {
        const apiUrl = "/supplier/find";
        return await httpRequest.post<IMdSupplierDetail[]>(apiUrl, searchVo, config);
    }

    async supplierDs(searchVo: IMdSupplierFields) {
        let { retData } = await this.find(searchVo);
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }));
    }

    async page(searchVo: IMdSupplierSearch) {
        const apiUrl = "/supplier/page";
        return await httpRequest.post<IPage<IMdSupplierDetail>>(apiUrl, searchVo);
    }

    async one(oneVo: IMdSupplierFields) {
        const apiUrl = "/supplier/one";
        return await httpRequest.post<IMdSupplierDetail>(apiUrl, oneVo);
    }

    async sync(syncVo: IMdSupplierFields) {
        const appPageUrl = "/supplier/sync";
        syncVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, syncVo, { timeout: LONG_REQUEST_TIMEOUT });
    }

    async syncPage(searchVo: IMdSupplierSearch) {
        const appPageUrl = "/supplier/syncPage";
        searchVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, searchVo);
    }

    async syncOne(oneVo: IMdSupplierFields) {
        const appPageUrl = "/supplier/syncPage";

        return await httpRequest.post<boolean>(appPageUrl, oneVo);
    }
}

export const supplierService = new SupplierService();
